module.exports = __webpack_public_path__ + "static/img/log.a7de7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/log.png
// module id = f7Se
// module chunks = 57